import React, { useEffect, useState } from 'react';
import {
  App, Button, Form, Tag,
} from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useSimpleModal } from '../../../Common/Modal/Simple';
import { useMessageError } from '../../../../hooks/common';
import SinglePageContainer from '../../../Common/SinglePageContainer';

import { AdminCreateParams, useAdminCreate } from '../../../../hooks/api/admins';

import { useUnsavedChanges } from '../../../../context/unsavedChanges';
import { isObjEqual } from '../../../../utils';
import { UserRole } from '../../../../enums/user';
import AdminFormItems from '../Form';
import { getUserStatusColor } from '../index';

const initialState: AdminCreateParams = {
  email: '',
  password: '',
  firstName: '',
  lastName: '',
  status: 'active',
  role: UserRole.ADMIN,
};

export default function AdminCreate(): React.ReactNode {
  const { id = '' } = useParams();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { open, contextHolder } = useSimpleModal();
  const [form] = Form.useForm<AdminCreateParams>();

  const adminCreate = useAdminCreate();

  /** Initial Values >>> */
  const { unsavedChanges, handleUnsavedChanges } = useUnsavedChanges();
  const [initialValues, setInitialValues] = useState(initialState); // <User>

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(initialValues);
    handleUnsavedChanges(false);
  }, [initialValues]);
  /** <<< Initial Values */

  const handleSubmit = (values: AdminCreateParams) => {
    form.validateFields().then(({ ...val }) => {
      const regularUserUpdate = () => (
        adminCreate.fetch({
          ...val,
          status: undefined,
        }, id)
          .then((res) => {
            if (res?.id) {
              message.success('Admin created successfully');
              navigate(`/admins/${res.id}`);
              // setInitialValues(prepareValues(res));
            }
          }));

      handleUnsavedChanges(false);
      regularUserUpdate();
    });
  };

  useMessageError([adminCreate]);

  const handleFieldsChange = () => {
    if (!initialValues) return;
    handleUnsavedChanges(!isObjEqual(
      initialValues,
      form.getFieldsValue(),
    ));
  };

  return (
    <SinglePageContainer
      title="Create admin"
      breadcrumbItems={[]}
      stickyHeader
      extra={(
        <>
          {initialValues.status ? (
            <Tag color={getUserStatusColor(initialValues.status)} className="capitalize-first-letter">
              {initialValues.status}
            </Tag>
          ) : null}
          <Button
            type="primary"
            onClick={form.submit}
            icon={<SaveOutlined />}
            loading={adminCreate.loading}
            disabled={!unsavedChanges}
          >
            Save
          </Button>
        </>
      )}
    >
      {contextHolder}
      <Form
        form={form}
        name="admin-form"
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={initialValues}
        onFieldsChange={handleFieldsChange}
        autoComplete="off"
      >
        <AdminFormItems data={initialValues} variant="create" />
      </Form>

    </SinglePageContainer>
  );
}
